import React from "react";
/** Services Import */
/** Components Import */
import HomeScreen from "../../Views/Home/Home";
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";

function Home(props) {
  const [inputs, setInputs] = React.useState({
    title: "",
    remark: "",
  });
  const [screenWidth, setScreenWidth] = React.useState(
    Commons.Dimentions().width
  );
  const [screenHeight, setScreenHeight] = React.useState(
    Commons.Dimentions().height
  );
  const [boardList, setBoardList] = React.useState([]);
  React.useEffect(() => {
    const HandleResize = () => {
      setScreenWidth(Commons.Dimentions().width);
      setScreenHeight(Commons.Dimentions().height);
    };
    window.addEventListener("resize", HandleResize);

    return () => window.removeEventListener("resize", HandleResize);
  }, []);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);
  const Init = async () => {
    let boardData = [];
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10120.Serach
      ).then((result) => {
        let data = result.data;
        setInputs({
          ...inputs,
          title: data[0].title ? data[0].title : "",
          remark: data[0].remarks,
        });
        for (let i = 0; i < data.length; i++) {
          boardData.push({
            type: "accodion",
            title: data[i].title ? data[i].title : "",
            value: data[i].remarks,
            date: Commons.DateFormating(data[i].createDate.toString(), 2),
          });
        }

        setBoardList(boardData);
      });
    } catch (e) {
    } finally {
    }
  };

  return (
    <HomeScreen
      inputs={inputs}
      setInputs={setInputs}
      screenHeight={screenHeight}
      screenWidth={screenWidth}
      boardList={boardList}
    />
  );
}

export default Home;
